import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "tea guide",
    date: "28 July, 2025",
    admin: "Thomas Kelly",
    heading: "6 Tea Types: A Beginner's Guide",
    content: 'Explore the world of tea through this essential beginner’s guide.',
    important: {
      content: "Understanding the different types of tea is the first step in appreciating their unique flavors, benefits, and brewing methods. From black to herbal, discover what suits your taste best.",
      intro: "Tea Basics"
    },
    paragraph: {
      para1: "Tea comes in various types, each offering a distinct flavor, aroma, and health benefit. The six primary types are Black, Green, White, Oolong, Herbal, and Pu-erh.",
      para2: "Black tea is known for its strong flavor and higher caffeine content, while Green tea offers a lighter taste and rich antioxidants. White tea is the most delicate, made from young tea leaves.",
      para3: "Oolong tea is partially fermented, combining the richness of black and the freshness of green tea. Herbal teas are caffeine-free and made from herbs, spices, and fruits rather than tea leaves.",
      para4: "Pu-erh tea undergoes fermentation and aging, offering earthy and complex flavors. Try each type to find your favorite and explore new blends from around the world."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2,
    ],
    tags: ["tea", "green", "guide"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Ava Thompson",
        date: "6 January, 2025",
        content: "This helped me understand the differences so much better. Thank you!",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Noah Kim",
            date: "6 January, 2025",
            content: "Same here! I’m now obsessed with oolong tea."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Emily Zhang",
        date: "6 January, 2025",
        content: "Perfect guide for someone like me who just got into tea."
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "morning brews",
    date: "21 July, 2025",
    admin: "Kath Smith",
    heading: "Best Morning Tea to Start Your Day",
    content: 'Begin your mornings with the right cup of tea for energy and calm.',
    important: {
      content: "A warm cup of tea can set the tone for a productive day. Discover the best morning teas that provide the right balance of flavor and gentle stimulation to wake you up naturally.",
      intro: "Tea Mornings"
    },
    paragraph: {
      para1: "Morning tea isn't just a ritual—it’s about choosing a blend that energizes and refreshes. Black teas like English Breakfast and Assam offer robust flavor and a moderate caffeine boost.",
      para2: "Green teas are another great choice, especially Sencha or Matcha, which provide sustained energy without the crash often associated with coffee.",
      para3: "For those who prefer caffeine-free options, herbal blends with ingredients like ginger, lemongrass, and peppermint can invigorate the senses and support digestion.",
      para4: "Pair your morning tea with light snacks like toast or fruit to enhance its effects. The key is to find a tea that aligns with your pace and sets a calm, focused tone for the day."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2,
    ],
    tags: ["tea", "morning", "healthy"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Lucas Green",
        date: "3 February, 2025",
        content: "I switched from coffee to black tea after reading this. Love it!",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Maya Brooks",
            date: "3 February, 2025",
            content: "Same here! Assam has become my go-to every morning."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Ella James",
        date: "3 February, 2025",
        content: "Great tips! I never knew green tea could work so well in the morning."
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Green Routine",
    date: "11 July, 2025",
    admin: "Harry Boyle",
    heading: "How to Drink Green Tea Everyday",
    content: 'Make green tea a healthy part of your daily lifestyle with simple tips.',
    important: {
      content: "Green tea is packed with antioxidants and health benefits, but consistency is key. Learn how to make green tea part of your daily routine without getting bored or overwhelmed.",
      intro: "Daily Wellness"
    },
    paragraph: {
      para1: "Green tea can be enjoyed throughout the day—start your morning with a light brew like Sencha and wind down your evenings with a soothing Jasmine or Mint blend.",
      para2: "Avoid over-brewing or using boiling water. Let the water cool slightly before steeping to preserve the tea’s delicate flavors and prevent bitterness.",
      para3: "Experiment with adding lemon, honey, or mint to keep your daily cup interesting. Cold brews in summer or warm infusions in winter make it enjoyable year-round.",
      para4: "Set a daily green tea habit by pairing it with another routine—like reading, journaling, or your afternoon break. The gentle energy and mental clarity it offers are perfect for any time."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2,
    ],
    tags: ["tea", "green", "healthy"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Sofia Patel",
        date: "10 April, 2025",
        content: "These tips helped me finally make green tea a part of my mornings. Love the lemon tip!",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Jayden Ross",
            date: "10 April, 2025",
            content: "I agree! Mint green tea has become a new favorite of mine."
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Hannah Lee",
        date: "10 April, 2025",
        content: "Great advice on brewing temperature—my tea tastes much better now."
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Black Benefits",
    date: "4 July, 2025",
    admin: "Amy Hudson",
    heading: "Top 5 Best Healthy Black Tea Selection",
    content: "Explore the healthiest black tea choices packed with flavor and wellness benefits.",
    important: {
      content: "Black tea is more than just a morning pick-me-up. These five varieties offer a great balance of bold taste and health perks—from antioxidants to heart health support.",
      intro: "Wellness Picks"
    },
    paragraph: {
      para1: "Start with **Assam Black Tea** — strong, malty, and energizing. It's great for improving focus and metabolism, making it ideal for morning routines.",
      para2: "**Darjeeling Tea** comes next with its floral aroma and light body. It's rich in polyphenols, which may support digestion and reduce inflammation.",
      para3: "**English Breakfast Tea** is a classic. It blends several black teas to create a robust cup that's perfect with a splash of milk and pairs well with hearty breakfasts.",
      para4: "Rounding out the list are **Yunnan Tea** and **Earl Grey**. Yunnan is smooth and full-bodied, great for reducing stress, while Earl Grey offers bergamot-infused refreshment with potential heart-health benefits."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2,
    ],
    tags: ["tea", "black", "healthy"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Liam Walker",
        date: "16 June, 2025",
        content: "Great breakdown! I’ve been drinking Darjeeling for years, and now I want to try Yunnan too.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Priya Malhotra",
            date: "16 June, 2025",
            content: "Same here! Never knew black tea could offer this many health benefits."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Oscar Bennett",
        date: "16 June, 2025",
        content: "Would love a guide on brewing the perfect cup for each of these!"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Black Benefits",
    date: "22 June, 2025",
    admin: "Sandeep Patil",
    heading: "5 Amazing Hibiscus Tea Benefits",
    content: "Discover the powerful health benefits hidden in every cup of hibiscus tea.",
    important: {
      content: "Hibiscus tea isn't just vibrant and refreshing—it's also packed with nutrients and wellness perks. From heart support to immune boosts, it's a great addition to your daily routine.",
      intro: "Health & Herbal"
    },
    paragraph: {
      para1: "**Rich in Antioxidants:** Hibiscus tea is full of anthocyanins and vitamin C, helping to fight free radicals and support healthy aging.",
      para2: "**Supports Heart Health:** Studies suggest hibiscus may help lower blood pressure and maintain healthy cholesterol levels when consumed regularly.",
      para3: "**Boosts Immunity:** Thanks to its high vitamin C content, hibiscus tea helps strengthen the immune system and reduce the severity of colds.",
      para4: "**Aids in Digestion & Weight Management:** Its natural acids and diuretic properties promote better digestion and may assist in weight loss efforts."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2,
    ],
    tags: ["tea", "herbal", "healthy"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Farah Nadeem",
        date: "19 September, 2025",
        content: "I love how refreshing hibiscus tea is! I didn’t realize it helped with blood pressure too.",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Zara Ahmed",
            date: "19 September, 2025",
            content: "Same! Now I have even more reason to enjoy it daily."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Rehan Qureshi",
        date: "19 September, 2025",
        content: "This was super informative. Any tips on the best way to brew it without losing the benefits?"
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Tea Pairing",
    date: "18 June, 2025",
    admin: "Sandeep Patil",
    heading: "Best Sandwich Idea with Afternoon Tea",
    content: "Pair your afternoon tea with the perfect sandwich for a delightful experience.",
    important: {
      content: "Afternoon tea isn't complete without a light, flavorful sandwich. Whether you prefer savory or refreshing fillings, a good sandwich elevates your tea time into a proper tradition.",
      intro: "Tea & Bites"
    },
    paragraph: {
      para1: "**Cucumber Cream Cheese:** A classic choice, combining crisp cucumber slices with smooth cream cheese on soft white or whole grain bread.",
      para2: "**Egg Salad Delight:** Whipped eggs, mayonnaise, and a touch of mustard served between lightly toasted slices for a hearty option.",
      para3: "**Smoked Salmon & Dill:** For something more refined, smoked salmon with a hint of lemon and fresh dill offers a gourmet touch.",
      para4: "**Custom Pairings:** Match your sandwich with complementary teas like Earl Grey for citrusy blends or Darjeeling for a mellow flavor profile."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2,
    ],
    tags: ["tea", "pairing", "herbal"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Neha Kapoor",
        date: "19 September, 2025",
        content: "I made the cucumber cream cheese sandwich and it paired so well with my jasmine tea!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Sana Riaz",
            date: "19 September, 2025",
            content: "It’s my go-to too! Perfect for summer tea sessions."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Imran Saeed",
        date: "19 September, 2025",
        content: "These ideas are great. Would love to see more sandwich and tea combos!"
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Tea Guide",
    date: "10 June, 2025",
    admin: "Thomas Kelly",
    heading: "Beginner’s Guide to 6 Types of Tea",
    content: "Discover the six essential tea types every beginner should know.",
    important: {
      content: "From bold black tea to delicate white tea, each type offers a unique taste, aroma, and benefit. Understanding their differences is the first step to becoming a true tea lover.",
      intro: "Tea Education"
    },
    paragraph: {
      para1: "**Black Tea:** Known for its robust flavor and higher caffeine, it's a morning favorite worldwide.",
      para2: "**Green Tea:** Light, grassy, and rich in antioxidants, perfect for daily detox and calming rituals.",
      para3: "**Oolong Tea:** A semi-oxidized tea offering a balance between black and green, often floral or fruity in taste.",
      para4: "**White, Herbal & Pu-erh:** White tea is the most delicate, herbal teas are caffeine-free infusions, and pu-erh is fermented, known for its earthy depth and digestive benefits."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2,
    ],
    tags: ["tea", "guide", "green"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Ayaan Malik",
        date: "6 January, 2025",
        content: "This guide helped me finally understand the difference between all these tea types!",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Leena Qureshi",
            date: "6 January, 2025",
            content: "Same! I had no idea white tea was so light and subtle."
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Jared Benson",
        date: "6 January, 2025",
        content: "Really helpful breakdown. Looking forward to trying Pu-erh next."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Morning Brews",
    date: "2 June, 2025",
    admin: "Kath Smith",
    heading: "Top Morning Teas to Kickstart Your Day",
    content: "Start your mornings with energy and clarity with the right cup of tea.",
    important: {
      content: "Morning teas like English Breakfast, Masala Chai, and Matcha are not only flavorful but also energizing. Choosing the right tea can set the tone for a productive and balanced day.",
      intro: "Morning Tea Picks"
    },
    paragraph: {
      para1: "**English Breakfast Tea:** A strong black tea blend that’s perfect for waking up the senses and pairing with a hearty breakfast.",
      para2: "**Masala Chai:** Spiced and bold, this Indian classic combines black tea with warming spices like cardamom and ginger for a morning boost.",
      para3: "**Matcha Green Tea:** A vibrant powdered green tea loaded with antioxidants, offering calm energy and enhanced focus.",
      para4: "**Lemon Ginger or Tulsi Tea:** For a lighter option, these herbal teas are soothing yet refreshing, especially on calm or slower mornings."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2,
    ],
    tags: ["tea", "morning", "guide"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Nadia Yusuf",
        date: "3 February, 2025",
        content: "Matcha is my go-to every morning. Love the energy boost without the crash!",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Jake D’Souza",
            date: "3 February, 2025",
            content: "I’m a big fan of English Breakfast with a splash of milk. Classic start."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Hira Shah",
        date: "3 February, 2025",
        content: "Thanks for the suggestions—trying Masala Chai tomorrow!"
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Green Routine",
    date: "19 May, 2025",
    admin: "Harry Boyle",
    heading: "Daily Green Tea Drinking Tips",
    content: "Maximize the benefits of green tea with simple daily habits.",
    important: {
      content: "Drinking green tea regularly boosts metabolism, supports digestion, and provides antioxidants. Learn how to make it a seamless part of your routine without losing its benefits.",
      intro: "Green Tea Guide"
    },
    paragraph: {
      para1: "**Pick the right time:** Avoid drinking green tea on an empty stomach. Ideal times are mid-morning or early afternoon.",
      para2: "**Don’t overbrew:** Brew your tea at 75–85°C for 1–3 minutes. Overbrewing can make it bitter and reduce nutritional value.",
      para3: "**Limit intake:** Stick to 2–3 cups a day. Too much can lead to caffeine overload or interfere with iron absorption.",
      para4: "**Pair smartly:** Avoid pairing green tea with iron-rich meals. Instead, enjoy it between meals or with light snacks."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2,
    ],
    tags: ["tea", "green", "healthy"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Sarah Lim",
        date: "10 April, 2025",
        content: "Didn’t know about the iron absorption issue. Super helpful tips!",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Ali Khan",
            date: "10 April, 2025",
            content: "I usually drink it before breakfast—time to change that!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Meera Chaudhry",
        date: "10 April, 2025",
        content: "I love green tea and now I know how to drink it better—thank you!"
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Black Benefits",
    date: "5 May, 2025",
    admin: "Harry Boyle",
    heading: "5 Healthiest Black Teas to Try",
    content: "Discover the most beneficial black teas for your daily cup.",
    important: {
      content: "Black tea isn't just bold in flavor—it's packed with health benefits too. From heart health to energy boosts, these five black teas can elevate your wellness routine.",
      intro: "Black Tea Benefits"
    },
    paragraph: {
      para1: "**1. Assam Tea:** Rich in antioxidants and caffeine, it’s great for morning energy and heart support.",
      para2: "**2. Darjeeling Tea:** A light and floral tea with anti-inflammatory properties that’s gentle on the stomach.",
      para3: "**3. Ceylon Tea:** High in potassium, it helps regulate blood pressure and supports hydration.",
      para4: "**4. Yunnan Tea:** Known for aiding digestion and boosting immunity. **5. English Breakfast:** A classic strong tea that’s ideal for alertness and stamina."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2,
    ],
    tags: ["tea", "black", "healthy"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Nathan Yeo",
        date: "10 April, 2025",
        content: "Darjeeling is my favorite! Didn’t know it had anti-inflammatory benefits.",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Clara Wu",
            date: "10 April, 2025",
            content: "Assam really helps me stay awake at work. Great list!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Aarav Patel",
        date: "10 April, 2025",
        content: "Going to try Yunnan next. Love these wellness tea guides!"
      }
    ]
  }

];

export default blogs;